const config = require("./config");
const serialize = require("locutus/php/var/serialize");
import AbstractForm from "./AbstractForm";
class UnsubscribeForm extends AbstractForm {
  constructor(element) {
    super(element);
  }
  getFormData() {
    let data = {
      action: "unsubscribeform",
      params: [{
        responseType: "plain",
        lang: this.pageLang,
        client_domain: this.websiteDomain,
        url: [location.protocol, "//", location.host, location.pathname].join(""),
        "unsubscribe-email": ""
      }]
    };
    let email = this.element.querySelector('[name="Email"]').value.trim();
    data.params[0]["unsubscribe-email"] = email;
    if (this.element.querySelector('[name="privacyPolicy"]')) {
      let checked = this.element.querySelector('[name="privacyPolicy"]').checked;
      data.params[0].privacyPolicy = checked;
    }
    console.log({
      data: data
    });
    return {
      data: {
        data: serialize(data)
      },
      rawData: data
    };
  }
  sendAction() {
    return new Promise((resolve, reject) => {
      this.removerErrorMessages("Email");
      let data = this.getFormData();
      let valid = this.validateAllData(data.rawData.params[0]);
      if (valid === false) {
        resolve(false);
        return;
      }
      this.clearAllErrors();
      this.postData(config.getNewsletterBrandedUrl(), data.data).then(data => {
        resolve({
          data
        });
      }).catch(e => {
        reject({
          e
        });
      });
    });
  }
}
export default UnsubscribeForm;